import { render, staticRenderFns } from "./warn.vue?vue&type=template&id=0c63cf9e&scoped=true&"
import script from "./warn.vue?vue&type=script&lang=js&"
export * from "./warn.vue?vue&type=script&lang=js&"
import style0 from "./warn.vue?vue&type=style&index=0&id=0c63cf9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c63cf9e",
  null
  
)

export default component.exports